/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiRectPlayIcon16Light } from './MediaUiRectPlayIcon16Light';
import { MediaUiRectPlayIcon16Regular } from './MediaUiRectPlayIcon16Regular';
import { MediaUiRectPlayIcon16Solid } from './MediaUiRectPlayIcon16Solid';
import { MediaUiRectPlayIcon20Light } from './MediaUiRectPlayIcon20Light';
import { MediaUiRectPlayIcon20Regular } from './MediaUiRectPlayIcon20Regular';
import { MediaUiRectPlayIcon20Solid } from './MediaUiRectPlayIcon20Solid';
import { MediaUiRectPlayIcon24Regular } from './MediaUiRectPlayIcon24Regular';
import { MediaUiRectPlayIcon24Solid } from './MediaUiRectPlayIcon24Solid';
import { MediaUiRectPlayIcon32Regular } from './MediaUiRectPlayIcon32Regular';
import { MediaUiRectPlayIcon64Regular } from './MediaUiRectPlayIcon64Regular';
var sizes = {
    16: {
        light: MediaUiRectPlayIcon16Light,
        regular: MediaUiRectPlayIcon16Regular,
        solid: MediaUiRectPlayIcon16Solid,
    },
    20: {
        light: MediaUiRectPlayIcon20Light,
        regular: MediaUiRectPlayIcon20Regular,
        solid: MediaUiRectPlayIcon20Solid,
    },
    24: {
        regular: MediaUiRectPlayIcon24Regular,
        solid: MediaUiRectPlayIcon24Solid,
    },
    32: {
        regular: MediaUiRectPlayIcon32Regular,
    },
    64: {
        regular: MediaUiRectPlayIcon64Regular,
    },
};
export var MediaUiRectPlayIcon = forwardRef('MediaUiRectPlayIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
